import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';

gsap.registerPlugin(Draggable);

export default class isDraggable {
  constructor(element) {
    this.element = element;

		// Check the screen size
    this.checkMediaQuery();

		// Add event listener for screen size changes
    window.addEventListener('resize', () => this.checkMediaQuery());
  }

  checkMediaQuery() {
   // Check if the screen size is larger than min-width: 37.5em
    if (window.matchMedia("(min-width: 37.5em)").matches) {
      Draggable.create(this.element, {
        type: 'scrollLeft',
        cursor: 'default',
        autoScroll: 0,
        allowContextMenu: true,
      });
    } else {
		// Remove draggable if the screen size does not meet the condition
      Draggable.get(this.element)?.kill();
    }
  }
}
